export default "__VITE_ASSET__DZgX8DYu__"